import styled, { Theme } from '@mint-lib/styled';
import { SxProps } from '@mui/material/styles';

import Checkbox from '../Checkbox/Checkbox.jsx';
import TableBodyCell, {
  TableBodyCellProps,
} from '../TableBodyCell/TableBodyCell.jsx';

export interface TableCellCheckboxProps extends TableBodyCellProps {
  sx?: SxProps<Theme>;
  bgColor?: TableBodyCellProps['bgColor'];
  checkboxProps?: React.ComponentProps<typeof Checkbox>;
}

const TableCellCheckbox = ({
  bgColor = 'default',
  checkboxProps,
  ...props
}: TableCellCheckboxProps) => {
  return (
    <StyledTableCell bgColor={bgColor} {...props}>
      <Checkbox {...checkboxProps} />
    </StyledTableCell>
  );
};

export default TableCellCheckbox;

const StyledTableCell = styled(TableBodyCell)({
  width: '28px',
  height: '40px',
  padding: '0 0 0 8px',
});
